export default "__VITE_ASSET__rpHWo_Xu__"